export default __webpack_public_path__ + "static/media/icons8-download-64.259039c2.svg";